module.exports = __webpack_public_path__ + "media/images/image2-00b87751df2756d9ae5386d0d4003bbe.png";